export default __webpack_public_path__ + "static/media/16 CUANDO EL PROPOSITO ES VOLAR.8dd62d92.png";